module.exports = __webpack_public_path__ + "img/tutorial_war_02.047d0e89.gif";